import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
/**
import CommonButtonBadge from '../components/CommonButtonBadge';
*/
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import CommonImagePreview from '../components/CommonImagePreview';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

const ATTACH_FILE_CONTENT_URL = `api/master/attach_files/files`;
class DataTableEECNetsData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageUrls: {} 
        };
    }

    componentDidMount() {
        this.loadImages();
    }
    
    componentDidUpdate(prevProps) {
        const prevRows = prevProps.DataTable?.rows || [];
        const currentRows = this.props.DataTable?.rows || [];
    
        const hasChanged = prevRows.length !== currentRows.length ||
            prevRows.some((prevRow, i) => {
                const currRow = currentRows[i];
                return prevRow.id !== currRow.id ||
                       prevRow.logo_file_id !== currRow.logo_file_id;
            });
    
        if (hasChanged) {
            this.loadImages();
        }
    }
    
    loadImages = async () => {
        const { DataTable } = this.props;
        const imageUrls = await Actions.loadImageBlobUrls({
            rows: DataTable.rows,
            fileField: "logo_file_id",
            idField: "id",
            baseUrl: ATTACH_FILE_CONTENT_URL
        });
        this.setState({ imageUrls });
    };

    render() {

        let props = this.props;

        let { onSetEdit, onDropDownChange, onReorder, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, UserCookie } = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
            if (
                row.status !== '0' 
            ) { deleteChecked++; }
        });

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead>
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-100p"></th>
                                        <th className="th-width-auto"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-width-175p"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            {deleteChecked > 0 && (
                                                <Form.Check 
                                                    type="checkbox"
                                                    checked={Deletes.checkAll}
                                                    onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {

                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                        
                                        rowId++;

                                        let del = true;
                                        if (
                                            row.status === '0'                                            
                                        ) { del = false; }

                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {!util.isEmpty(row.logo_file_id) && (
                                                            <CommonImagePreview
                                                                src={this.state.imageUrls?.[row.id] || null}
                                                                width={80}
                                                                height={80}
                                                                alt="โลโก้"
                                                            />
                                                        )}
                                                    </td>
                                                    <td className="text-truncate" title={row.name}>
                                                        {row.name}

                                                        {(row.contact || row.email) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                {row.contact && <><i className="fa-classic fa-light fa-phone fa-fw me-2"></i>เบอร์ติดต่อ {row.contact}<span className="me-2"></span></>}
                                                                {row.email && <><i className="fa-classic fa-light fa-at fa-fw me-2"></i>อีเมล {row.email}</>}
                                                            </p>
                                                        )}

                                                        {(row.mission_rows > 0 || row.network_operation_rows > 0 ) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                {row.mission_rows > 0 && (
                                                                    <>
                                                                        <i className="fa-classic fa-light fa-flag fa-fw me-2"></i>ภารกิจ
                                                                        <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.mission_rows, true)}</Badge>
                                                                    </>
                                                                )}
                                                                
                                                                {row.network_operation_rows > 0 && (
                                                                    <>
                                                                        <i className="fa-classic fa-light fa-briefcase fa-fw me-2"></i>การดำเนินการของศูนย์
                                                                        <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.network_operation_rows, true)}</Badge>
                                                                    </>
                                                                )}
                                                            </p>
                                                        )}

                                                        {(row.network_performance_rows > 0 || row.future_plans_rows > 0 || row.network_partner_rows > 0 ) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                {row.network_performance_rows > 0 && (
                                                                    <>
                                                                        <i className="fa-classic fa-light fa-badge-check fa-fw me-2"></i>ผลการดำเนินงานของศูนย์
                                                                        <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.network_performance_rows, true)}</Badge>
                                                                    </>
                                                                )}

                                                                {row.future_plans_rows > 0 && (
                                                                    <>
                                                                        <i className="fa-classic fa-light fa-calendar-lines-pen fa-fw me-2"></i>แผนการดำเนินงาน
                                                                        <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.future_plans_rows, true)}</Badge>
                                                                    </>
                                                                )}

                                                                {row.network_partner_rows > 0 && (
                                                                    <>
                                                                        <i className="fa-classic fa-light fa-handshake fa-fw me-2"></i>หน่วยงานพันธมิตร
                                                                        <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.network_partner_rows, true)}</Badge>
                                                                    </>
                                                                )}                                                                
                                                            </p>
                                                        )}

                                                        {(row.illustration_rows > 0 || row.public_data_rows > 0) && (
                                                            <p className="title-xs mt-1 mb-0">

                                                                {row.illustration_rows > 0 && (
                                                                    <>
                                                                        <i className="fa-classic fa-light fa-paperclip fa-fw me-2"></i>ภาพประกอบ
                                                                        <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.illustration_rows, true)}</Badge>
                                                                    </>
                                                                )}

                                                                {row.public_data_rows > 0 && (
                                                                    <>
                                                                        <i className="fa-classic fa-light fa-rectangle-ad fa-fw me-2"></i>เอกสารเผยแพร่/นำเสนอ
                                                                        <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.public_data_rows, true)}</Badge>
                                                                    </>
                                                                )}                                                                
                                                            </p>
                                                        )}
                                                                                                              
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="up-direction" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onReorder({id: row.id, sequenceField: 'seq', filter: [], direction: 'up'})} 
                                                            order={{direction: 'up', row: rowId, rows: DataTable.pagination.totalRows}}
                                                            operation={Operation}
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="down-direction" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onReorder({id: row.id, sequenceField: 'seq', filter: [], direction: 'down'})}
                                                            order={{direction: 'down', row: rowId, rows: DataTable.pagination.totalRows}}
                                                            operation={Operation}
                                                        />
                                                    </td>
                                                    <td>
                                                        <CommonDropdown
                                                            element="DataTable"
                                                            input={{id: 'status', value: row.status}}
                                                            option={{source: 'options', section: 'status', item: 'default'}}
                                                            callback={(e, element) => onDropDownChange('update-something', e, element, {key: 'id', value: row.id} )} 
                                                            disabled={!(['0', '1'].includes(UserCookie.types))} // 0 = admin, 1 = EEC staff
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="edit" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.id})} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.id}
                                                                checked={Deletes.deletes.includes(row.id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableEECNetsData;
